import { UncategorizedMeetingOverride } from 'Overrides/UncategorizedMeeting';
import { ClientExperienceSavesEscalatedHouseholdsOverride } from 'Overrides/ClientExperienceSavesEscalatedHouseholds';
import {
  BulkRolloverRecommendationQuestionnaireDialog,
  BulkRolloverRecommendationQuestionnaireTable,
  RolloverRecommendationQuestionnaireTimeline,
} from 'Overrides/BulkRolloverRecommendationQuestionnaireTable';
import { LinkingAttemptsBaseOverride } from 'Components/AdvisorApp/Viewport/LinkingAttempts/LinkingAttemptsContent';
import { IdentityVerificationReviewsTable } from 'Overrides/identityVerificationReviewsOverride';

import { ClientViewOverride } from 'Overrides/ClientView';
import {
  ManagedAccountAllocationCleanupTableOverride,
} from 'Views/Page/Content/Templates/ManagedAccountAllocationCleanupTemplate/MetaOverrideSet';
import { FacetPlanAccount } from 'Overrides/FacetPlan';
import {
  BillingDetailsProfileSubpageMetaOverride,
} from 'Views/Page/Content/Templates/Profile/Templates/ProfileTemplate/Subpages/BillingDetailsProfileSubpage/BillingDetailsProfileSubpageMetaOverride';
import { AgentActionItemTableOverride } from 'Overrides/ActionItem';
import {
  MissionControlNoteOverride,
  MissionControlNoteOverrideContextMenu,
  NoteHistoryOverride,
  TimelineNoteOverride,
} from './Note';
import { FeatureToggleCreateOverride, FeatureToggleEditOverride, FeatureToggleTableOverride } from './FeatureToggle';
import { TemplateEditOverride, TemplateNoteEditOverride, TemplateTableOverride } from './Template';
import GoalFormOverride from './GoalForm';
import { AccountRequestSummaryTableOverride, AchRelationshipResourceOverride } from './Apex';
import { SimpleActionItemEditOverride, SimpleActionItemTableOverride } from './SimpleActionItem';
import { RemindersCardOverride, RemindersTableOverride } from './Reminder';
import { MeetingSummaryEditOverride, MeetingSummaryTableOverride } from './MeetingSummary';
import AccountSupportTableOverride from '../Overrides/AccountSupport';
import BulkCommunicationSummaryTable from '../Overrides/BulkCommunicationSummaryTable';
import { PlaidLinkSessionEditOverride, PlaidLinkSessionTableOverride } from './PlaidLinkSession';
import { CuratedContentArticleEditOverride, CuratedContentArticleTableOverride } from './CuratedContentArticle';

// DO NOT REMOVE - GENERATOR REPLACE ME - RESOURCE IMPORTS DICTIONARY

// TODO: Add all overrides to this list
export default {
  MissionControlNoteOverride,
  MissionControlNoteOverrideContextMenu,
  FeatureToggleTableOverride,
  BulkRolloverRecommendationQuestionnaireDialog,
  BulkRolloverRecommendationQuestionnaireTable,
  LinkingAttemptsBaseOverride,
  RolloverRecommendationQuestionnaireTimeline,
  AccountSupportTableOverride,
  FeatureToggleCreateOverride,
  FeatureToggleEditOverride,
  TimelineNoteOverride,
  GoalFormOverride,
  TemplateTableOverride,
  TemplateEditOverride,
  TemplateNoteEditOverride,
  SimpleActionItemTableOverride,
  SimpleActionItemEditOverride,
  AgentActionItemTableOverride,
  RemindersTableOverride,
  RemindersCardOverride,
  IdentityVerificationReviewsTable,
  NoteHistoryOverride,
  AccountRequestSummaryTableOverride,
  AchRelationshipResourceOverride,
  MeetingSummaryTableOverride,
  MeetingSummaryEditOverride,
  UncategorizedMeetingOverride,
  PlaidLinkSessionTableOverride,
  PlaidLinkSessionEditOverride,
  ClientExperienceSavesEscalatedHouseholdsOverride,
  CuratedContentArticleTableOverride,
  CuratedContentArticleEditOverride,
  BulkCommunicationSummaryTable,
  ClientViewOverride,
  ManagedAccountAllocationCleanupTableOverride,
  FacetPlanAccount,
  BillingDetailsProfileSubpageMetaOverride,
  // DO NOT REMOVE - GENERATOR REPLACE ME - RESOURCE DICTIONARY
};
